export const getRandomVariant = (variants = []) => {
  if (!variants.length) return "";
  return variants[Math.floor(Math.random() * variants.length)];
};